import { useState, useCallback, useRef } from 'react';
import { format } from 'date-fns';
import api from '../../../services/api';

export const useStats = () => {
  const [stats, setStats] = useState({
    totalSales: 0,
    monthlySales: 0,
    dailyVisits: 0,
    monthlyRevenue: 0,
    clientAcceptanceRate: 0,
    topSponsors: [],
    monthlyTotal: 0,
    successRate: 0,
    pendingRate: 0,
    refusalRate: 0
  });
  const [loading, setLoading] = useState(false);
  const abortControllerRef = useRef(null);
  const cacheRef = useRef(new Map());

  const loadStats = useCallback(async (month, force = false) => {
    // Annuler la requête précédente si elle existe
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const formattedMonth = format(month, 'yyyy-MM');

    // Cache hit (skipped when force=true — used after a mutation to refresh)
    if (!force && cacheRef.current.has(formattedMonth)) {
      setStats(cacheRef.current.get(formattedMonth));
      return;
    }

    // Créer un nouveau AbortController
    abortControllerRef.current = new AbortController();
    
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const { data } = await api.get('/opticians/stats', {
        params: { month: formattedMonth },
        headers: { Authorization: `Bearer ${token}` },
        signal: abortControllerRef.current.signal
      });
      
      // Mettre en cache
      cacheRef.current.set(formattedMonth, data);
      setStats(data);
    } catch (err) {
      if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
        console.error('Erreur stats:', err);
      }
    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  }, []);

  return { stats, loading, loadStats };
};
